// import './index.scss';

import React, { FC, useState } from "react";
import { Button, Modal } from "antd";

const AreaApplyBtn: FC = () => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);


    const toggleVisible = () => {
        setVisible(!visible);
    };

    const saveAreaHandle = () => {
        console.log(1);
        setLoading(true);
    }

    return (
        <>
            <Button type="primary" style={{margin: 8}} ghost onClick={toggleVisible}>
                申请区域权限
            </Button>

            {visible && (
                <Modal title="区域权限申请" visible={visible} confirmLoading={loading} cancelText="取消" okText="保存" onOk={saveAreaHandle}  onCancel={toggleVisible}>
                    <div>AreaApply 组件</div>
                </Modal>
            )}
        </>
    );
};

export default AreaApplyBtn;
